import {faMagnifyingGlass} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Text} from '@rdcomponents/text/text';
import {Button} from 'antd';
import {useState} from 'react';

import {classNames} from '../../../util/css';
import {QuickSearchModal} from '../quick-search/quick-search-modal';

import * as styles from './search-button.scss';

type PropsType = {
    inlineCollapsed: boolean;
};

export function SearchButton(props: PropsType): JSX.Element {
    const {inlineCollapsed} = props;
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Button
                className={classNames(styles.SearchButton, {
                    [styles.SearchButton__collapsed]: inlineCollapsed,
                })}
                icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onClick={() => setIsModalOpen(true)}
                type={inlineCollapsed ? 'text' : 'default'}
            >
                {!inlineCollapsed && <Text secondary stringKey="NAVIGATION__QUICK_SEARCH__INPUT_PLACEHOLDER" />}
            </Button>
            <QuickSearchModal onClose={() => setIsModalOpen(false)} open={isModalOpen} />
        </>
    );
}
